/* Llama Land theme copy of the web-motion kit runtime (creative-studio/web-motion/kit/core/boot.js, LNMotion 1.0.0).
   One change for production (BUILD-CONTRACT rule 8): the hidden-tab auto-reload (reloadOnShow / armReloadOnShow) is
   removed. A tab that boots hidden stays on the composed still page; it never reloads itself. Loaded deferred, homepage
   only, after the GSAP files and before ll-home.js (snippets/ll-head.liquid). */
/* LNMotion 1.0.0 · the shared web-motion runtime (creative-studio/web-motion/kit/core/boot.js)
   Distilled from the Bold Directions concept pages (Orchard to Gummy, The Farm Stand, 2026-09-23).
   Full API and usage: kit/core/README.md.

   The one rule: CSS paints the composed, readable end state. Motion is an enhancement that starts
   only when it can finish. LNMotion decides the mode once, early, and puts it on <html>:
     html.js       JavaScript ran.
     html.motion   motion allowed (timelines, pins, loops may run).
     html.static   composed still page: reduced motion, a tab that booted hidden, ?motion=static,
                   or a runtime fallback (an error, a stall, the failsafe).
     html.pre      motion only, brief: decoration waits for its intro (lifted by releasePre() or a timer).
   It also sets data-motion="motion|static" and data-motion-reason on <html>.

   Why hidden tabs boot static: the in-app review pane runs tabs hidden, so requestAnimationFrame,
   IntersectionObserver and native lazy loading never fire there. A GSAP .from() would sit at its
   start state forever. Judge motion only in real Chrome.

   Inline this file once, after the GSAP <script> tags if they are in <head>, before the page script.
   Optional config, set before this file runs: window.LNMotionConfig = { ... } (see DEFAULTS). */
(function (W, D) {
  'use strict';
  if (W.LNMotion && W.LNMotion.version) return;

  var VERSION = '1.0.0';
  var H = D.documentElement;
  var DEFAULTS = {
    pre: true,               // add html.pre while motion is allowed (decoration start states only)
    preTimeout: 3000,        // ms: html.pre always lifts by then
    failsafe: 4000,          // ms: if motion has not started by then, go static
    watchdog: 1500,          // ms after start: no animation frame while visible = a stall
    stall: 'static',         // what a stall does: 'static' (composed page) or 'timers' (pump GSAP on a timer)
    pauseHidden: true,       // pause the GSAP global timeline while the tab is hidden
    fontsCap: 800,           // ms: longest wait for document.fonts.ready before start
    frameTimeout: 250,       // ms: start on the first animation frame or this timer, whichever comes first
    plugins: null,           // null: register every known GSAP plugin that is loaded; or a list of names
    lagSmoothing: [1000, 16],// gsap.ticker.lagSmoothing (keeps slow first frames from skipping the intro)
    ignoreMobileResize: true,// ScrollTrigger.config: no refresh when the mobile URL bar shows or hides
    clearProps: ['transform', 'translate', 'rotate', 'scale', 'opacity', 'visibility',
      'stroke-dashoffset', 'stroke-dasharray'], // inline props toStatic() removes from GSAP-touched elements
    debug: false
  };
  var PLUGINS = ['ScrollTrigger', 'ScrollToPlugin', 'Observer', 'CustomEase', 'CustomBounce', 'CustomWiggle',
    'SplitText', 'MorphSVGPlugin', 'DrawSVGPlugin', 'MotionPathPlugin', 'Flip', 'Draggable', 'InertiaPlugin',
    'Physics2DPlugin', 'PhysicsPropsPlugin', 'ScrambleTextPlugin', 'TextPlugin', 'ExpoScaleEase', 'RoughEase', 'SlowMo'];
  /* Material eases proven on the concept pages (CustomEase paths). */
  var EASES = {
    settle: 'M0,0 C0.22,0 0.3,1.16 0.5,1.16 0.64,1.16 0.72,0.97 0.82,0.985 0.88,0.995 0.95,1.004 1,1', // a jar sets down
    paper: 'M0,0 C0.2,0.8 0.2,1 1,1',                       // paper and type settle
    snap: 'M0,0 C0.3,1.6 0.5,1 1,1',                        // bubbles, stickers
    juice: 'M0,0 C0.65,0 0.35,1 1,1',                       // liquid, purée
    lid: 'M0,0 C0.5,-0.3 0.3,1.35 1,1',                     // anticipation then twist shut
    ink: 'M0,0 C0.2,0 0.1,1.08 0.46,1.02 0.7,0.99 0.84,1 1,1', // a print plate registers
    squish: 'M0,0 C0.3,0 0.35,1.25 0.55,1.05 0.7,0.95 0.85,1.01 1,1', // gummy squash and recover
    awning: 'M0,0 C0.14,0 0.24,1.14 0.44,1.08 0.58,1.03 0.66,0.97 0.76,0.99 0.86,1.01 0.93,1 1,1' // cloth unrolls
  };

  var cfg = {}, k;
  for (k in DEFAULTS) cfg[k] = DEFAULTS[k];
  var user = W.LNMotionConfig || {};
  for (k in user) if (Object.prototype.hasOwnProperty.call(user, k)) cfg[k] = user[k];

  var now = function () { return (W.performance && performance.now) ? performance.now() : Date.now(); };
  var mq = function (q) { try { return !!(W.matchMedia && W.matchMedia(q).matches); } catch (e) { return false; } };
  var qp = (function () { try { return new URLSearchParams(W.location.search).get('motion'); } catch (e) { return null; } })();

  var S = {
    mode: null, reason: null,
    reduced: mq('(prefers-reduced-motion: reduce)'),
    hiddenBoot: D.visibilityState === 'hidden',
    fine: mq('(hover: hover) and (pointer: fine)'),
    started: false, stalled: false, frames: 0,
    t0: now(), tStart: null, plugins: [], errors: []
  };
  var queue = [], listeners = {}, staticHandlers = [], loops = [];
  var preT = 0, failT = 0, cleaned = false;

  function log() { if (cfg.debug && W.console) console.log.apply(console, ['[LNMotion]'].concat([].slice.call(arguments))); }
  function emit(name, data) { (listeners[name] || []).slice().forEach(function (fn) { try { fn(data, api); } catch (e) { report(e); } }); }
  function report(e) { S.errors.push(String(e && e.message || e)); if (W.console) console.error('[LNMotion]', e); }
  function setFlags() {
    H.classList.toggle('motion', S.mode === 'motion');
    H.classList.toggle('static', S.mode === 'static');
    H.setAttribute('data-motion', S.mode);
    if (S.reason) H.setAttribute('data-motion-reason', S.reason); else H.removeAttribute('data-motion-reason');
  }

  /* ---------- 1. decide the mode (runs as soon as this file is evaluated) ---------- */
  function decide() {
    H.classList.add('js');
    if (qp === 'static') return markStatic('forced');
    if (S.reduced) return markStatic('reduced-motion');
    if (S.hiddenBoot && qp !== 'on') { markStatic('hidden-boot'); return; }
    S.mode = 'motion'; S.reason = null; setFlags();
    if (cfg.pre) { H.classList.add('pre'); preT = setTimeout(releasePre, cfg.preTimeout); }
    failT = setTimeout(function () { if (!S.started) toStatic('failsafe'); }, cfg.failsafe);
  }
  function markStatic(reason) { S.mode = 'static'; S.reason = reason; H.classList.remove('pre'); setFlags(); log('static:', reason); }
  function releasePre() { clearTimeout(preT); H.classList.remove('pre'); }

  /* ---------- 2. boot: DOM ready -> fonts (capped) -> first frame or timer -> start ---------- */
  function fontsReady(cap) {
    return new Promise(function (res) {
      var done = false, fin = function () { if (!done) { done = true; res(); } };
      setTimeout(fin, cap);
      try { if (D.fonts && D.fonts.ready) D.fonts.ready.then(fin, fin); else fin(); } catch (e) { fin(); }
    });
  }
  function boot() {
    fontsReady(cfg.fontsCap).then(function () {
      if (S.mode === 'motion' && !W.gsap) toStatic('no-gsap');
      if (S.mode !== 'motion') { start(); return; }
      registerGSAP();
      frame(start, cfg.frameTimeout);
    });
  }
  function start() {
    if (S.started) return;
    S.started = true; S.tStart = now(); clearTimeout(failT);
    emit('start', S.mode);
    var q = queue; queue = [];
    q.forEach(run);
    if (S.mode === 'motion') { armWatchdog(); refreshOnLoad(); }
  }
  function run(fn) {
    try { fn(api); }
    catch (e) { report(e); if (S.mode === 'motion') toStatic('error: ' + (e && e.message || e)); }
  }

  /* ---------- 3. the frame watchdog ---------- */
  function armWatchdog() {
    var seen = false;
    raf(function () { seen = true; S.frames++; });
    setTimeout(function () {
      if (seen || S.mode !== 'motion') return;
      if (D.hidden) { // a real background tab: frames are paused on purpose; check again once visible
        var again = function () { if (!D.hidden) { D.removeEventListener('visibilitychange', again); armWatchdog(); } };
        D.addEventListener('visibilitychange', again);
        return;
      }
      stall();
    }, cfg.watchdog);
  }
  function stall() {
    S.stalled = true; emit('stall', cfg.stall); log('stall: no animation frames while visible');
    if (cfg.stall === 'timers' && W.gsap) {
      // drive GSAP from a timer until real frames arrive (manual ticks never queue extra frames)
      gsap.ticker.lagSmoothing(0);
      var id = setInterval(function () { gsap.ticker.tick(); }, 33);
      loops.forEach(function (L) { if (L.wanted) { L.sleep(); L.wake(); } });
      raf(function () { clearInterval(id); S.stalled = false; gsap.ticker.lagSmoothing(cfg.lagSmoothing[0], cfg.lagSmoothing[1]); loops.forEach(function (L) { if (L.wanted) { L.sleep(); L.wake(); } }); });
      return;
    }
    toStatic('stall');
  }
  function raf(fn) { return W.requestAnimationFrame ? W.requestAnimationFrame(fn) : setTimeout(fn, 16); }

  /* ---------- 4. fall back to the composed static page ---------- */
  function toStatic(reason) {
    if (S.mode === 'static' && cleaned) return;
    var wasMotion = S.mode === 'motion';
    S.reason = wasMotion ? (reason || 'runtime') : (S.reason || reason || 'runtime');
    S.mode = 'static';
    clearTimeout(failT); releasePre();
    loops.forEach(function (L) { L.sleep(); });
    if (W.ScrollTrigger) { try { ScrollTrigger.getAll().forEach(function (s) { s.kill(true); }); } catch (e) { /* keep going */ } }
    if (W.gsap) {
      try { gsap.globalTimeline.clear(); } catch (e) { /* keep going */ }
      // undo every start state GSAP wrote inline (hidden offsets, zero opacity, undrawn strokes)
      var all = D.querySelectorAll('*');
      for (var i = 0; i < all.length; i++) {
        var el = all[i];
        if (!el._gsap || !el.style) continue;
        for (var j = 0; j < cfg.clearProps.length; j++) el.style.removeProperty(cfg.clearProps[j]);
      }
    }
    cleaned = true; setFlags();
    if (wasMotion) staticHandlers.forEach(function (fn) { try { fn(S.reason, api); } catch (e) { report(e); } });
    emit('static', S.reason);
    if (W.console && wasMotion) console.warn('[LNMotion] motion disabled:', S.reason);
    if (!S.started) start();
  }

  /* ---------- 5. GSAP helpers ---------- */
  function registerGSAP(names) {
    if (!W.gsap) return [];
    var list = names || cfg.plugins || PLUGINS, got = [];
    list.forEach(function (n) { if (W[n] && S.plugins.indexOf(n) < 0) { got.push(W[n]); S.plugins.push(n); } });
    if (got.length) { try { gsap.registerPlugin.apply(gsap, got); } catch (e) { report(e); } }
    if (cfg.lagSmoothing) gsap.ticker.lagSmoothing(cfg.lagSmoothing[0], cfg.lagSmoothing[1]);
    if (W.ScrollTrigger && cfg.ignoreMobileResize) ScrollTrigger.config({ ignoreMobileResize: true });
    return S.plugins.slice();
  }
  function eases(map) {
    var out = {}, m = map || EASES;
    if (!W.gsap) return out;
    Object.keys(m).forEach(function (n) {
      if (W.CustomEase) { try { CustomEase.create(n, m[n]); } catch (e) { report(e); } }
      out[n] = gsap.parseEase(n) || gsap.parseEase('power2.out');
    });
    return out;
  }
  /* ScrollTrigger vars for an entrance that plays with the scroll once, then locks at its end state:
     never reverts on the way back up, and full-page captures show final layouts. */
  function once(vars) {
    var prev = vars.onLeave;
    vars.onLeave = function (s) { if (prev) prev(s); if (s.animation) s.animation.progress(1); s.kill(false, true); };
    return vars;
  }
  var refreshT = 0, refreshedH = -1;
  function refresh(delay) {
    if (!W.ScrollTrigger || S.mode !== 'motion') return;
    clearTimeout(refreshT);
    refreshT = setTimeout(function () { try { ScrollTrigger.sort(); ScrollTrigger.refresh(); refreshedH = H.scrollHeight; } catch (e) { report(e); } }, delay == null ? 120 : delay);
  }
  /* media that loads into a reserved box moves nothing; a full refresh mid-scroll costs a frame-dropping
     re-measure and can nudge pins, so only refresh when the page height actually changed */
  function refreshIfMoved() { if (H.scrollHeight !== refreshedH) refresh(); }
  function refreshOnLoad() {
    if (!W.ScrollTrigger) return;
    refresh(0);
    W.addEventListener('load', function () { refresh(0); });
    try { if (D.fonts && D.fonts.ready) D.fonts.ready.then(function () { refresh(); }); } catch (e) { /* no font API */ }
    [].forEach.call(D.images, function (img) { if (!img.complete) img.addEventListener('load', refreshIfMoved, { once: true }); });
    [].forEach.call(D.querySelectorAll('video'), function (v) { v.addEventListener('loadedmetadata', refreshIfMoved, { once: true }); });
  }

  /* ---------- 6. frames, loops, near, idle ---------- */
  /* run fn once, on the next animation frame or after ms, whichever comes first */
  function frame(fn, ms) {
    var done = false, go = function () { if (done) return; done = true; fn(); };
    raf(go); setTimeout(go, ms == null ? 250 : ms);
  }
  /* a frame loop: step(dt, t) runs every frame and returns false to sleep. Sleeps while hidden and
     wakes on return; after a stall (stall:'timers') it runs on a 16 ms timer. Never runs in static. */
  function loop(step, o) {
    o = o || {};
    var L = { running: false, wanted: false, last: 0, id: 0, timer: false };
    var tick = function (t) {
      L.id = 0;
      var tt = (typeof t === 'number' && t > 0) ? t : now();
      var dt = Math.min(o.maxDt || 0.05, Math.max(0, (tt - L.last) / 1000)); L.last = tt;
      var keep;
      try { keep = step(dt, tt) !== false; } catch (e) { report(e); keep = false; }
      if (!keep) { L.wanted = false; L.running = false; return; }
      if (D.hidden && !o.runHidden) { L.running = false; return; }
      schedule();
    };
    var schedule = function () { L.timer = S.stalled; L.id = L.timer ? setTimeout(tick, 16) : raf(tick); };
    L.wake = function () {
      if (S.mode !== 'motion') return L;
      L.wanted = true;
      if (L.running || (D.hidden && !o.runHidden)) return L;
      L.running = true; L.last = now(); schedule(); return L;
    };
    L.sleep = function () {
      if (L.id) { if (L.timer) clearTimeout(L.id); else if (W.cancelAnimationFrame) cancelAnimationFrame(L.id); }
      L.id = 0; L.running = false; L.wanted = false; return L;
    };
    loops.push(L);
    return L;
  }
  var idle = function (fn, timeout) {
    if (W.requestIdleCallback) return W.requestIdleCallback(fn, { timeout: timeout || 600 });
    return setTimeout(fn, 60);
  };
  /* run fn once when el comes within `margin` viewports. Content must never depend on it: use it for
     heavy work (atlases, WebGL, video posters). Backups for observer-less panes: a timer-throttled
     scroll sweep, an idle sweep at 4 s (within 3 viewports) and a late unconditional pass (9 s). */
  var nearQ = [], nearArmed = false;
  function near(el, fn, o) {
    o = o || {};
    if (!el) return function () {};
    var q = { el: el, done: false, go: null };
    q.go = function () { if (q.done) return; q.done = true; if (q.io) q.io.disconnect(); try { fn(el); } catch (e) { report(e); } };
    if (S.hiddenBoot) { q.go(); return function () {}; }
    nearQ.push(q); armNear(o.late == null ? 9000 : o.late);
    if ('IntersectionObserver' in W) {
      var m = (o.margin == null ? 1.5 : o.margin) * 100;
      q.io = new IntersectionObserver(function (es) { if (es.some(function (e) { return e.isIntersecting; })) q.go(); }, { rootMargin: m + '% 0px' });
      q.io.observe(el);
    }
    return function () { q.done = true; if (q.io) q.io.disconnect(); };
  }
  function nearSweep(all) {
    var vh = W.innerHeight;
    nearQ.forEach(function (q) {
      if (q.done) return;
      var r = q.el.getBoundingClientRect();
      if (all || (r.bottom > -3 * vh && r.top < 4 * vh)) idle(q.go);
    });
  }
  function armNear(late) {
    if (nearArmed) return; nearArmed = true;
    var t = 0;
    var onS = function () { if (!t) t = setTimeout(function () { t = 0; nearSweep(false); if (nearQ.every(function (q) { return q.done; })) W.removeEventListener('scroll', onS); }, 150); };
    W.addEventListener('scroll', onS, { passive: true });
    setTimeout(function () { nearSweep(false); }, 4000);
    if (late) setTimeout(function () { nearSweep(true); }, late);
  }

  /* ---------- 7. small utilities ---------- */
  var clamp = function (v, a, b) { a = a == null ? 0 : a; b = b == null ? 1 : b; return v < a ? a : v > b ? b : v; };
  var lerp = function (a, b, t) { return a + (b - a) * t; };
  var seg = function (p, a, b) { return p <= a ? 0 : p >= b ? 1 : (p - a) / (b - a); }; // local 0..1 inside [a, b]
  var rng = function (seed) { var a = seed | 0 || 7; return function () { a |= 0; a = a + 0x6D2B79F5 | 0; var t = Math.imul(a ^ a >>> 15, 1 | a); t = t + Math.imul(t ^ t >>> 7, 61 | t) ^ t; return ((t ^ t >>> 14) >>> 0) / 4294967296; }; };
  /* split an element's text into word spans (.w), kerning inside words preserved. Screen readers
     read the original text via aria-label; the spans are aria-hidden. Idempotent. */
  function splitWords(el) {
    if (!el) return [];
    if (el.__lnWords) return el.__lnWords;
    var text = el.textContent;
    var out = [];
    var walk = function (node) {
      [].slice.call(node.childNodes).forEach(function (n) {
        if (n.nodeType === 3) {
          var frag = D.createDocumentFragment();
          n.textContent.split(/(\s+)/).forEach(function (part) {
            if (!part) return;
            if (/^\s+$/.test(part)) { frag.appendChild(D.createTextNode(part)); return; }
            var s = D.createElement('span'); s.className = 'w'; s.textContent = part; s.setAttribute('aria-hidden', 'true');
            frag.appendChild(s); out.push(s);
          });
          node.replaceChild(frag, n);
        } else if (n.nodeType === 1 && !/^(BR|SVG|IMG)$/i.test(n.nodeName)) { walk(n); }
      });
    };
    walk(el);
    if (!el.hasAttribute('aria-label')) el.setAttribute('aria-label', text.replace(/\s+/g, ' ').trim());
    el.__lnWords = out;
    return out;
  }

  /* ---------- visibility + reduced-motion changes ---------- */
  D.addEventListener('visibilitychange', function () {
    if (D.hidden) {
      emit('hidden');
      if (cfg.pauseHidden && S.mode === 'motion' && W.gsap) gsap.globalTimeline.pause();
    } else {
      emit('visible');
      if (cfg.pauseHidden && S.mode === 'motion' && W.gsap) gsap.globalTimeline.resume();
      loops.forEach(function (L) { if (L.wanted && !L.running) L.wake(); });
    }
  });
  try {
    var rmq = W.matchMedia('(prefers-reduced-motion: reduce)');
    var onRm = function (e) { if (e.matches && S.mode === 'motion') toStatic('reduced-motion'); };
    if (rmq.addEventListener) rmq.addEventListener('change', onRm); else if (rmq.addListener) rmq.addListener(onRm);
  } catch (e) { /* no matchMedia */ }

  /* ---------- public API ---------- */
  var api = {
    version: VERSION,
    config: cfg,
    EASES: EASES,
    PLUGINS: PLUGINS,
    get motion() { return S.mode === 'motion'; },
    get mode() { return S.mode; },
    get reason() { return S.reason; },
    get reduced() { return S.reduced; },
    get hiddenBoot() { return S.hiddenBoot; },
    get finePointer() { return S.fine; },
    ready: function (fn) { if (typeof fn !== 'function') return api; if (S.started) run(fn); else queue.push(fn); return api; },
    on: function (name, fn) { (listeners[name] = listeners[name] || []).push(fn); return api; },
    onStatic: function (fn) { staticHandlers.push(fn); return api; },
    toStatic: toStatic,
    releasePre: releasePre,
    registerGSAP: registerGSAP,
    eases: eases,
    once: once,
    refresh: refresh,
    frame: frame,
    loop: loop,
    near: near,
    idle: idle,
    clamp: clamp, lerp: lerp, seg: seg, rng: rng,
    splitWords: splitWords,
    state: function () {
      return {
        version: VERSION, mode: S.mode, reason: S.reason, reduced: S.reduced, hiddenBoot: S.hiddenBoot,
        started: S.started, stalled: S.stalled, frames: S.frames,
        startMs: S.tStart == null ? null : Math.round(S.tStart - S.t0),
        plugins: S.plugins.slice(), errors: S.errors.slice(),
        scrollTriggers: W.ScrollTrigger ? ScrollTrigger.getAll().length : 0,
        loops: loops.filter(function (L) { return L.running; }).length
      };
    }
  };
  W.LNMotion = api;

  decide();
  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})(window, document);
